// extracted by mini-css-extract-plugin
export var addressFields = "_p9-0";
export var animationContainer = "_p9-1";
export var footer = "_p9-2";
export var lineItems = "_p9-3";
export var modalContent = "_p9-4";
export var orderName = "_p9-5";
export var strong = "_p9-6";
export var warning = "_p9-7";